import React, { memo, useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import css from './NuevosListados.css';
import axios from "axios";
import ReactHtmlParser from 'react-html-parser';

import FloatingWindow from "../../components/ui/window/FloatingWindow";
import PDFViewer from "../../components/ui/window/PDFViewer";

const dominio = `${window.location.protocol}//${window.location.host}`;

function NuevosListados(props) {

  let [reporteMensual, setReporteMensual] = useState(null);
  let [showPDFViewer, setShowPDFViewer] = useState(false);
  let [nuevosListadosContent, setNuevosListadosContent] = useState(null);

  let onClickReport = () => {
    setShowPDFViewer(!showPDFViewer);
  }

  useEffect(() => {
    let urlReporteMensual = `${dominio}/cms/o/documents/etf-bivasic-reporte-mensual/lang/${props.lang}`;
    let urlContenidoNuevosListados = `${dominio}/cms/o/documents/etf-nuevos-listados/lang/${props.lang}`;

    axios.get(urlReporteMensual)
      .then(response => {
        let pdfUrl = new URL(`${dominio}${response.data[0].url}`);
        setReporteMensual(pdfUrl.toString());
      })
      .catch(err => console.error("Error al obtener el PDF de la sección de reporte mensual. " + err.message));

    axios.get(urlContenidoNuevosListados)
      .then(response => {
        setNuevosListadosContent(response.data[0].html);
      })
      .catch(err => console.error("Error al obtener el contenido de la sección de nuevos listados. " + err.message));
  }, []);

  return (
    <div>
      <div className={css.nuevosListadosContent}>
        {ReactHtmlParser (nuevosListadosContent)}

        <br />
        <div className={[css.container_btn_reporte, "col-12 row"].join(" ")}>
          <button className={css.btn_reporte} onClick={onClickReport}>
            {props.lang === "es" ? "Reporte Mensual" : "Monthly Report"} <i className="fa fa-file" aria-hidden="true" />
          </button>
        </div>
      </div>

      {
        showPDFViewer ?
          <FloatingWindow show={showPDFViewer} closeWindowAction={onClickReport}
            content={
              <div className={[css.pdf_viewer, "row col-12"].join(" ")}>
                <PDFViewer url={reporteMensual} locale={props.lang} />
              </div>
            }
          /> : null
        }
    </div>
  );
}

NuevosListados.propTypes = {
    lang: PropTypes.string
}

export default memo(NuevosListados);
